<div class="hasTabs">
    <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg cat__core__top-sidebar--tabs">

    <span class="cat__core__title d-block mt-2 mb-0 mb-lg-2">
        <strong>{{page?.displayName}} Page</strong>
    </span>
    </nav>
    <div class="nav-tabs-horizontal tab-body">
        <ul ngbNav #tabSet="ngbNav" [(activeId)]="activeTab" class="nav-link-inside nav-tabs">
            <li [ngbNavItem]="'previewTab'">
                <a ngbNavLink>
                    <a [routerLink]="['/edit', pageId]" [queryParams]="getParamsForTab('previewTab')">
                        <span>Preview</span>
                    </a>
                </a>
                <ng-template ngbNavContent>
                    <app-preview [page]="page"></app-preview>
                </ng-template>
            </li>
            <li [ngbNavItem]="'postsTab'">
                <a ngbNavLink>
                    <a [routerLink]="['/edit', pageId]" [queryParams]="getParamsForTab('postsTab')">
                        <span class="d-block d-lg-none">Posts</span>
                        <span class="d-none d-lg-block">Manage Posts</span>
                    </a>
                </a>
                <ng-template ngbNavContent>
                    <app-posts [isPastItemPage]="isPastItemPage()" (onPostFormReady)="addForm($event)"></app-posts>
                </ng-template>
            </li>
            <li [ngbNavItem]="'commentsTab'" *ngIf="!isNationalTeamPage">
                <a ngbNavLink>
                    <a [routerLink]="['/edit', pageId]" [queryParams]="getParamsForTab('commentsTab')">
                        <span class="d-block d-lg-none">Comments</span>
                        <span class="d-none d-lg-block">Manage Comments</span>
                    </a>
                </a>
                <ng-template ngbNavContent>
                    <app-comments></app-comments>
                </ng-template>
            </li>
            <li [ngbNavItem]="'optionsTab'" *ngIf="showOptionsTab(cssClass)">
                <a ngbNavLink>
                    <a [routerLink]="['/edit', pageId]" [queryParams]="getParamsForTab('optionsTab')">
                        <span class="d-block d-lg-none">Options</span>
                        <span class="d-none d-lg-block">Page Options</span>
                    </a>
                </a>
                <ng-template ngbNavContent>
                    <app-page-options
                            (onInit)="addForm($event)"
                            [donationsAmounts]="donationAmounts"
                            [model]="page"
                            [isTeam]="isTeam"
                            [isNationalTeam]="isNationalTeamPage"
                            [isPastItemPage]="isPastItemPage()"
                            [cssClass]="cssClass"></app-page-options>
                </ng-template>
            </li>
            <li [ngbNavItem]="'feedTab'" *ngIf="showNewsFeedTab(cssClass) && !isNationalTeamPage">
                <a ngbNavLink>
                    <a *ngIf="!isTeam"
                       class="d-block d-lg-none"
                       [routerLink]="['/edit', pageId]"
                       [queryParams]="{ activeTab: 'feedTab' }">News feed</a>
                    <a *ngIf="isTeam"
                       class="d-block d-lg-none"
                       [routerLink]="['/edit', pageId]"
                       [queryParams]="{ isTeam: 1, activeTab: 'feedTab' }">News feed</a>
                    <a *ngIf="!isTeam"
                       class="d-none d-lg-block"
                       [routerLink]="['/edit', pageId]"
                       [queryParams]="{ activeTab: 'feedTab' }">Manage News feed</a>
                    <a *ngIf="isTeam"
                       class="d-none d-lg-block"
                       [routerLink]="['/edit', pageId]"
                       [queryParams]="{ isTeam: 1, activeTab: 'feedTab' }">Manage News feed</a>
                </a>
                <ng-template ngbNavContent>
                    <app-edit-news-feed></app-edit-news-feed>
                </ng-template>
            </li>
        </ul>
        <div [ngbNavOutlet]="tabSet" class="mt-2"></div>
    </div>

</div>
